import Button from "../Button";

const ContinueButton = ({ children, ...props }) => {
  return (
    <Button className="ms-4 btn btn-primary" {...props}>
      {children}
    </Button>
  );
};

export default ContinueButton;
